import { useAuth } from "@/routes/authProvider"
import {
  routesForAuthenticatedOnly,
  routesForNotAuthenticatedOnly,
  routesForPublic,
} from "@/routes/router"
import { Box, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import useIsMobile from "@/hooks/useIsMobile"
import React from "react"
import useIsTablet from "@/hooks/useIsTablet"
interface NavLinks {
  order: number
  label: string
  path: string
}

/**
 * TODO: This is inelegant, find a better way to do this
 * This function remaps calendar URLs to point to the
 * current date
 */
function mapLinkUrl(url: string): string {
  if (url.startsWith("/calendar")) {
    const date = new Date()
    return `/calendar/${date.getFullYear()}/${date.getMonth() + 1}`
  }

  return url
}

const NavLinks = () => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const { token } = useAuth()
  const navLinks: NavLinks[] = [
    ...(token ? routesForAuthenticatedOnly[0].children : []),
    ...(!token ? routesForNotAuthenticatedOnly : []),
    ...routesForPublic.filter(
      (item) => !["/about-us", "/attractions", "/events/:eventId"].includes(item.path)
    ),
  ].filter((item) => item?.label)

  const currLocation = window.location.pathname
  return (
    <Box
      sx={{
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <Stack
        direction="row"
        gap={isMobile ? 1 : isTablet ? 1.5 : 2}
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: "2em",
          outline: "1px solid #CCCCCC",
          height: isMobile || isTablet ? "1.8rem" : "2.5rem",
          paddingX: isMobile ? ".3rem" : "1.2rem",
          boxShadow: 2,
          "&:hover": {
            boxShadow: 4,
          },
        }}
      >
        {navLinks.map((element: NavLinks) => {
          return (
            <React.Fragment key={element.label}>
              <Box
                component={Link}
                to={mapLinkUrl(element.path)}
                sx={{
                  flex: 1,
                  display: "flex",
                  textDecoration: "none",
                  cursor: "pointer",
                  paddingY: isMobile ? ".2rem" : ".2rem",
                  paddingX: isMobile ? ".3rem" : "1.2rem",
                }}
                key={element.label}
              >
                <Typography
                  sx={{
                    textDecoration: "none",
                    color:
                      element.path === "/" && currLocation === "/"
                        ? "text.primary"
                        : currLocation.includes(
                            (element.label ?? "").toLowerCase()
                          )
                        ? "text.primary"
                        : "#7D7D7D",
                    fontSize: isMobile ? "14px" : "inherit",
                    fontWeight: 650,
                  }}
                >
                  {element.label}
                </Typography>
              </Box>
              {element.order !== 3 && (
                <Box
                  sx={{
                    backgroundColor: "#BBBBBB",
                    height: "24px",
                    width: "1px",
                    alignSelf: "center",
                  }}
                />
              )}
            </React.Fragment>
          )
        })}
      </Stack>
    </Box>
  )
}

export default NavLinks
